import { INITIAL_TERMS, INITIAL_PRIVACY, INITIAL_COOKIE_POLICY } from '@/src/services/legalService';

export const USER_AGREEMENT = INITIAL_TERMS;
export const PRIVACY_POLICY = INITIAL_PRIVACY;
export const DATA_PRIVACY = `### Data Privacy & Local Storage
eNvesta AI uses local device memory and secured cloud databases to store your reconnaissance scans and preferences.

- **Storage**: We do not sell your proprietary venture inputs.
- **Controls**: You can purge your device's local sandbox or configure tracking preferences directly in this console.
- **Compliance**: Adheres to strict data isolation protocols.`;

export const COOKIE_POLICY = INITIAL_COOKIE_POLICY;
